<template>
  <div class="home">
    <Carousel :banners="banners" />
    <Sobre />
    <div class="container">
      <NavJobs />
    </div>
    <Expertises />
    <Footer />
    <back-to-top text="Top"></back-to-top>
  </div>
</template>

<script>
// @ is an alias to /src
import Carousel from "@/components/Carousel.vue";
import NavJobs from "@/components/nav-jobs.vue";
import Sobre from "@/components/Sobre.vue";
import BackToTop from "vue-backtotop";
import Expertises from "@/components/Expertises.vue";
import Footer from "@/components/Footer.vue";

export default {
  data() {
    return {
      banners: ""
    };
  },
  name: "home",
  components: {
    Carousel,
    Sobre,
    NavJobs,
    BackToTop,
    Expertises,
    Footer
  }
};
</script>
